import React from 'react';
import { connect } from 'react-redux';
import paging from '@/hooks/paging';
import TokensTable from '../components/TokensTable';
import TokensPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/TokensPanelContainer';

const TokensPanelFull = ({
  tokens,
  filterTerm,
  category,
  readStatus,
  readErrors,
  total,
  currentPage,
  pageSize,
  pageCount,
  fetchData,
  updateFilterTerm,
  canRead,
  allowRoleLink,
  allowUserLink,
  canCreate,
  newToken,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus);
  return (
    <TokensPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-tokens-panel-full">
      <TokensTable
        tokens={tokens}
        readStatus={readStatus}
        readErrors={readErrors}
        category={category}
        total={total}
        pageCount={pageCount}
        pageSize={pageSize}
        currentPage={currentPage}
        filterTerm={filterTerm}
        fetchData={fetchData}
        updateFilterTerm={updateFilterTerm}
        allowRoleLink={allowRoleLink}
        allowUserLink={allowUserLink}
        canCreate={canCreate}
        newToken={newToken}
      />
    </TokensPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TokensPanelFull);
